import { render, staticRenderFns } from "./DirectNavigationFormScreen.vue?vue&type=template&id=5f047c2e&"
import script from "./DirectNavigationFormScreen.vue?vue&type=script&lang=ts&"
export * from "./DirectNavigationFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports